import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="bg-slate-50 min-h-screen font-sans pb-20">
      
      {/* ── 1. HERO BANNER ── */}
      <div className="relative text-white overflow-hidden" style={{ minHeight: '300px' }}>
        <img src="/SG (7).jpg" alt="Cookie Policy" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#001529] via-[#0d2d6b]/90 to-[#0d2d6b]/60" />
        <div className="absolute top-0 right-0 opacity-5 text-[180px] font-black select-none leading-none -mr-8 -mt-8">SGCL</div>
        
        <div className="relative z-10 px-4 md:px-20 py-16 max-w-4xl">
          <span className="bg-govt-orange text-white px-4 py-1 rounded-full text-xs font-black uppercase tracking-widest">
            Cookie Policy
          </span>
          <h1 className="text-4xl md:text-5xl font-black mt-4 mb-5 leading-tight uppercase italic">
            Cookie <span className="text-govt-orange">Policy</span>
          </h1>
          <p className="text-blue-100 font-bold border-l-4 border-govt-orange pl-5 italic max-w-2xl leading-relaxed text-base">
            This policy explains how Shramjivi Goodshed Corporation Limited uses cookies and digital indicators to optimize your browsing experience.
          </p>
        </div>

        {/* Tricolor border strip */}
        <div className="absolute bottom-0 left-0 right-0 h-1.5 flex">
          <div className="flex-1 bg-[#FF9933]" />
          <div className="flex-1 bg-white" />
          <div className="flex-1 bg-[#138808]" />
        </div>
      </div>

      {/* ── 2. CONTENT SECTION ── */}
      <div className="container mx-auto px-4 md:px-20 mt-12 max-w-5xl">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-8 md:p-12 space-y-10 relative overflow-hidden">
          {/* Saffron accent border */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#FF9933]" />

          {/* Document Header */}
          <div className="border-b border-slate-100 pb-8">
            <h2 className="text-govt-blue font-black text-2xl uppercase tracking-wider">Cookie Policy</h2>
            <div className="mt-4 flex flex-col md:flex-row gap-4 text-xs font-bold text-slate-500 uppercase">
              <p>🌐 <span className="text-slate-700">Websites:</span> www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
              <p>🏢 <span className="text-slate-700">Owned &amp; Operated By:</span> Shramjivi Goodshed Corporation Limited</p>
            </div>
          </div>

          {/* Content sections */}
          <div className="space-y-8 text-slate-600 text-sm leading-relaxed font-semibold">
            
            {/* Section 1 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">1.</span> Introduction
              </h3>
              <p className="pl-6">
                This Cookie Policy explains how Shramjivi Goodshed Corporation Limited ("SGCL", "Company", "we", "our", or "us") uses cookies and similar technologies when you visit or interact with our website.
              </p>
              <p className="pl-6 font-bold text-govt-blue">
                By continuing to browse or use this website, you consent to the use of cookies in accordance with this Cookie Policy.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 2 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">2.</span> What Are Cookies?
              </h3>
              <p className="pl-6">
                Cookies are small text files stored on your computer, mobile device, or browser when you visit a website. Cookies help websites:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Remember user preferences.</li>
                <li>Improve website performance.</li>
                <li>Enhance user experience.</li>
                <li>Analyze visitor behavior.</li>
                <li>Maintain security and functionality.</li>
              </ul>
              <p className="pl-6 text-xs text-slate-400 italic">
                Cookies do not normally contain information that directly identifies an individual user.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 3 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">3.</span> Types of Cookies We Use
              </h3>
              
              <div className="pl-6 space-y-4">
                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-blue">A. Essential Cookies</h4>
                  <p className="text-xs text-slate-600 font-semibold leading-relaxed">
                    These cookies are necessary for the proper functioning of the website, including website security, session management, form submissions, login authentication (if applicable), and navigation functionality.
                  </p>
                  <p className="text-[11px] font-bold text-red-600/80 uppercase">
                    Without these cookies, certain website features may not function correctly.
                  </p>
                </div>

                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-blue">B. Performance &amp; Analytics Cookies</h4>
                  <p className="text-xs text-slate-600 font-semibold leading-relaxed">
                    These cookies help us understand how visitors interact with our website by collecting information such as pages visited, time spent, traffic statistics, browser information, and device type.
                  </p>
                  <p className="text-[11px] font-bold text-slate-400 uppercase">
                    This information is generally aggregated and anonymous.
                  </p>
                </div>

                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-blue">C. Functional Cookies</h4>
                  <p className="text-xs text-slate-600 font-semibold leading-relaxed">
                    These cookies help remember user preferences and improve browsing experience, including language choices, region preferences, form data retention, and other personalized settings.
                  </p>
                </div>

                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-blue">D. Security Cookies</h4>
                  <p className="text-xs text-slate-600 font-semibold leading-relaxed">
                    Security cookies help protect the website against unauthorized access, fraudulent activity, malicious attacks, and security threats, maintaining website integrity.
                  </p>
                </div>
              </div>
            </section>

            <hr className="border-slate-100" />

            {/* Section 4 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">4.</span> Information Collected Through Cookies
              </h3>
              <p className="pl-6">
                Cookies may collect limited information such as IP Address, Browser Type, Device Type, Operating System, Referring Website, Date and Time of Visit, and Website Usage Patterns.
              </p>
              <p className="pl-6 text-xs text-slate-400 italic">
                This information is primarily used for technical, analytical, and security purposes.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 5 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">5.</span> Third-Party Cookies
              </h3>
              <p className="pl-6">
                The website may use third-party services that place cookies on users' devices. Examples include Google Analytics, Cloudflare, Website Security Services, Embedded Content Providers, and Government Website Widgets (where applicable).
              </p>
              <p className="pl-6 font-bold">
                These third parties maintain their own privacy and cookie policies. The Company does not control third-party cookies. Users are encouraged to review the policies of such providers.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 6 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">6.</span> Government Portal Links &amp; External Resources
              </h3>
              <p className="pl-6">
                This website may contain links to official Government of India platforms and public information resources including National Portal of India (https://www.india.gov.in), MyGov (https://www.mygov.in), and Integrated Government Online Directory (https://www.igod.gov.in).
              </p>
              <p className="pl-6">
                Any cookies used by such external websites are governed by their respective policies. Shramjivi Goodshed Corporation Limited has no control over cookies or tracking technologies used by external websites.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 7 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">7.</span> Managing Cookies
              </h3>
              <p className="pl-6">
                Most web browsers automatically accept cookies. Users may choose to accept all cookies, reject cookies, delete stored cookies, or receive notifications before cookies are stored. Cookie settings can generally be managed through browser preferences (Google Chrome, Mozilla Firefox, Microsoft Edge, Safari, Opera).
              </p>
              <p className="pl-6 font-bold text-red-600/90 italic">
                Please note that disabling cookies may affect website functionality and user experience.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 8 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">8.</span> Cookie Consent
              </h3>
              <p className="pl-6">
                Where required by applicable laws or regulations, users may be presented with a cookie notification banner requesting consent before certain categories of cookies are activated. By continuing to use the website after such notice, users may be deemed to have accepted the use of cookies as described in this policy.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 9 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">9.</span> Data Protection
              </h3>
              <p className="pl-6">
                Information collected through cookies is handled in accordance with our Privacy Policy and applicable data protection requirements. Reasonable security measures are implemented to safeguard collected information from unauthorized access, disclosure, alteration, or misuse.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 10 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">10.</span> Changes to This Cookie Policy
              </h3>
              <p className="pl-6">
                Shramjivi Goodshed Corporation Limited reserves the right to modify or update this Cookie Policy at any time. Any updates will be published on this page along with the revised effective date. Users are encouraged to review this policy periodically.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 11 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">11.</span> Contact Information
              </h3>
              <div className="pl-6 space-y-4">
                <p>Shramjivi Goodshed Corporation Limited</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs font-bold text-slate-700 bg-slate-50 p-6 rounded-2xl border border-slate-100 uppercase">
                  <div className="space-y-2">
                    <p>🌐 Website: www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
                    <p>✉️ Email: support@shramjivicorp.com / info@shramjivicorporation.co.in</p>
                    <p>📞 Contact: +91 73659 61803 / +91 97070 55354</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-[10px] text-govt-orange">Registered Office:</p>
                    <p className="leading-relaxed">
                      D/14, Satyajit Roy Co-operative Market, Champasari More,<br />
                      Ward No. 46, Pradhan Nagar, Siliguri,<br />
                      Darjeeling, West Bengal – 734003
                    </p>
                  </div>
                </div>
              </div>
            </section>

          </div>

          {/* Saffron / Green tricolor banner at the bottom of card */}
          <div className="mt-10 pt-6 border-t border-slate-100 text-center text-[10px] font-black uppercase text-slate-400 tracking-widest leading-loose">
            Note: By using this website, you acknowledge that you have read and understood this Cookie Policy and consent to the use of cookies as described herein. <br />
            © Shramjivi Goodshed Corporation Limited. All Rights Reserved.
          </div>

        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
